// @ts-nocheck
// -- General UI setup --------

(function () {
	// Toggle "scrolled" class on scroll
	let isScrolled = false;
	window.addEventListener('scroll', function () {
		if (!isScrolled && this.window.scrollY > 20) {
			isScrolled = true;
			document.body.classList.add('scrolled');
		} else if (isScrolled && this.window.scrollY <= 20) {
			isScrolled = false;
			document.body.classList.remove('scrolled');
		}
	});

	// Add is-touch class on on load
	if (
		'ontouchstart' in window ||
		navigator.maxTouchPoints > 0 ||
		navigator.msMaxTouchPoints > 0
	) {
		document.body.classList.add('is-touch');
	} else {
		document.body.classList.add('no-touch');
	}
})();

document.addEventListener('DOMContentLoaded', function () {
	// -- Notifications --------
	window.notyf = new Notyf({
		types: [
			{
				type: 'success',
				background: '#009f7d',
			},
		],
	});

  // -- Search --------
  const searchButton = document.querySelector('.open-search');
  if(searchButton) {
    searchButton.addEventListener('click', function(event) {
      event.preventDefault();
      const searchForm = document.getElementById('search_form');
      if(searchForm) {
        searchForm.classList.toggle('show');
        const searchInput = searchForm.querySelector('input[name="q"]');
        if(searchInput) {
          searchInput.focus();
        }
      }
    });
  }

	// -- Mobile menu --------
  const hamburger = document.querySelector('.hamburger');
  if(hamburger) {
    hamburger.addEventListener('click', function(event) {
      event.preventDefault();
      document.body.classList.add('mobile-menu-open');
    });
  }
  const mobileMenuClose = document.querySelector('#close-mobile-menu');
  if(mobileMenuClose) {
    mobileMenuClose.addEventListener('click', function(event) {
      event.preventDefault();
      document.body.classList.remove('mobile-menu-open');
    });
  }

	// Mobile menu sub-menu toggle
	$('#mobile-menu ul li > a').on('click', function () {
		if ($(this).parent().find('.sub-menu').length) {
			if ($(this).parent().find('.sub-menu').hasClass('open')) {
				if ($(this).attr('href') != '#') {
					return true;
				}
				$(this).parent().find('.sub-menu').removeClass('open');
			} else {
				$('#mobile-menu ul li > .sub-menu').removeClass('open');
				$(this).parent().find('.sub-menu').addClass('open');
			}
			return false;
		}
		if ($(this).attr('href') == '#') {
			return false;
		} else {
			return true;
		}
	});
});

// -- Slideshows --------
$(function () {
	if ($('.swiper-container.banner-slideshow').length) {
		new Swiper('.swiper-container.banner-slideshow', {
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				prevEl: '.banner-slider-controls.control-previous',
				nextEl: '.banner-slider-controls.control-next',
			},
			autoplay: {
				delay: 10000,
			},
			loop: true,
		});
	}

	// Tile slideshow
	if ($('.swiper-container.tile-slideshow').length) {
		new Swiper('.swiper-container.tile-slideshow', {
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			autoplay: {
				delay: 5000,
			},
			loop: true,
		});
	}
});


// -- Other --------
$(function () {
	function openDistributors(distributor) {
		$('.distributors-section .hidden-content').removeClass('show');
		$('#' + distributor.data('target')).addClass('show');
		return false;
	}
	$('#North, #London, #South_West').on('click', function () {
		return openDistributors($(this));
	});
});
